/**
 * Helpers for public profile share links.
 * Prefer username slugs when available; fall back to UUID.
 */

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isProfileUuid(value) {
  return UUID_RE.test(String(value || "").trim());
}

/**
 * Normalize a username for URL use (strip @, lowercase).
 */
export function normalizeProfileUsername(username) {
  const raw = String(username || "").trim();
  if (!raw) return "";
  const withoutAt = raw.startsWith("@") ? raw.slice(1) : raw;
  return withoutAt.toLowerCase();
}

/**
 * Path segment used in /profile/:identifier
 */
export function getProfileShareSlug({ username, userId } = {}) {
  const slug = normalizeProfileUsername(username);
  if (slug) return slug;
  const id = String(userId || "").trim();
  return id || "";
}

/**
 * Absolute share URL for a profile.
 */
export function buildProfileShareUrl({ username, userId, origin } = {}) {
  const slug = getProfileShareSlug({ username, userId });
  if (!slug) return "";
  const base =
    origin ||
    (typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "https://civixthread.com");
  return `${base.replace(/\/$/, "")}/profile/${slug}`;
}
